module.exports = "data:image/gif;base64,R0lGODlhEAAWAPABAPMCAgAAACH5BAkZAAEAIf8LTkVUU0NBUEUyLjADAQAAACwAAAAAEAAWAAACNIwPmceo2txbMcxXL4yatg5kHRNaI2KAppWOS6m+4Sm3U2vC22qLn5cTXSokIJF3VP1OgQIAIfkECRkAAQAsAAAAABAAFgCA////AAAAAjSMD5nHqNrcWzHMVy+MmrYOZB0TWiNigKaVjkupvuEpt1Nrwttqi5+XE10qJCCRd1T9ToECADs="


//////////////////
// WEBPACK FOOTER
// ./src/img/asl/record_start.gif
// module id = 1210
// module chunks = 438